import axiosInstance from './https';

export async function fireApi({
  endpoint,
  method = 'get',
  payload = null,
  extraHeaders = {},
  params = {},
  config = {}, // 👈 opt-in config
  skipAuth = false
}) {
  try {
    const headers = {
      'Content-Type': 'application/json',
      ...extraHeaders
    };

    const response = await axiosInstance.request({
      url: endpoint,
      method,
      headers,
      params,
      data: payload,
      skipAuth,
      ...config // 👈 responseType injected only when needed
    });

    const contentType = response.headers?.['content-type'] || '';

    /* =====================================================
       🔹 FILE DOWNLOADS (SAFE + CORRUPTION-FREE)
       ===================================================== */
    if (
      config?.responseType === 'blob' || // 👈 explicit opt-in
      response.data instanceof Blob // 👈 already binary
    ) {
      return {
        success: true,
        data: response.data
      };
    }

    /* =====================================================
       🔹 JSON RESPONSES (UNCHANGED)
       ===================================================== */
    if (contentType.includes('application/json')) {
      if (response.data?.status === 'error') {
        return {
          success: false,
          message: response?.data?.message || response?.data?.msg || false,
          error: response?.data?.message || 'Server not responding',
          endpoint
        };
      }
      return { success: true, data: response.data };
    }

    /* =====================================================
       🔹 FALLBACK (LEGACY SUPPORT)
       ===================================================== */
    return { success: true, data: response.data };
  } catch (error) {
    if (error?.response?.status === 403) {
      setTimeout(() => {
        sessionStorage.clear();
      }, 5000);
    }

    const apiMessage =
      error?.response?.data?.errors?.[0]?.message || // 🔹 validation errors
      error?.response?.data?.message || // 🔹 normal message
      error?.response?.data?.msg || // 🔹 alternate
      error?.message || // 🔹 axios fallback
      'Server not responding';

    return {
      success: false,
      message: apiMessage,
      description: error?.response?.data?.description,
      error: apiMessage,
      endpoint
    };
  }
}
